import { memo } from "react";
import { CardContainer } from "#scripts/keyboard-demo/components/CardContainer.tsx";
import { CLabel } from "#scripts/keyboard-demo/createKeyboardDemo.ts";
import { AtomValue } from "#scripts/lib/jotai/AtomValue.tsx";
import type { UID } from "#scripts/vmc/WorldState.ts";
import { useComponent } from "#scripts/world-state-demo/world-state-context.ts";

// Guided by @docs/WorldState.md
/**
 * Card content component - focuses on rendering the label and help text.
 * Container concerns (focus, color, interactions) are handled by CardContainer.
 *
 * Memoized to prevent re-renders when parent component updates but uid hasn't changed.
 */
export const Card = memo(function Card({ uid }: { uid: UID }) {
  // The card has minimal knowledge of the business logic
  const label = useComponent(uid, CLabel);
  return (
    <CardContainer uid={uid}>
      <h3 data-loc="phosphor-blog/scripts/keyboard-demo/components/Card.tsx:20:11" data-name="h3">
        {/* AtomValue simply renders the reactive value directly as a string */}
        <AtomValue atom={label.titleAtom} />
      </h3>
      <div data-loc="phosphor-blog/scripts/keyboard-demo/components/Card.tsx:24:12" data-name="div" className="card-shortcuts">
        <AtomValue atom={label.helpTextAtom} />
      </div>
    </CardContainer>
  );
});
